import { withInstall } from '@sgui-plus/utils/with-install'

import Card from './src/card.vue'

export const SgCard = withInstall(Card)
export default SgCard

export * from './src/card'
